"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ENABLED = exports.CAN_UNSET = exports.CAN_SET = void 0;
var ENABLED = 'enabled';
exports.ENABLED = ENABLED;
var CAN_SET = 'canSet';
exports.CAN_SET = CAN_SET;
var CAN_UNSET = 'canUnset';
exports.CAN_UNSET = CAN_UNSET;
//# sourceMappingURL=constants.js.map
